import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/svg/close.svg'


const _withScopeId = n => (_pushScopeId("data-v-c9ff8aea"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "h-screen bg-[var(--bg-color)] overflow-scroll"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = { class: "flex flex-col gap-y-5 px-[72px] py-16" }
const _hoisted_5 = { class: "flex flex-col gap-y-16" }
const _hoisted_6 = { class: "flex flex-col gap-y-10 px-10" }
const _hoisted_7 = { class: "flex flex-col px-[45px]" }
const _hoisted_8 = { for: "excursion" }
const _hoisted_9 = { class: "flex flex-col px-[45px]" }
const _hoisted_10 = { for: "date" }
const _hoisted_11 = { class: "flex flex-col px-[45px]" }
const _hoisted_12 = { for: "adults" }
const _hoisted_13 = { class: "flex flex-col px-[45px]" }
const _hoisted_14 = { for: "childrens" }
const _hoisted_15 = { class: "flex flex-col gap-y-10 px-10" }
const _hoisted_16 = { class: "flex flex-col px-[45px]" }
const _hoisted_17 = { for: "name" }
const _hoisted_18 = { class: "flex flex-col px-[45px]" }
const _hoisted_19 = { for: "phone" }
const _hoisted_20 = { class: "flex flex-col px-[45px]" }
const _hoisted_21 = { for: "email" }
const _hoisted_22 = { class: "flex flex-col px-[45px]" }
const _hoisted_23 = { for: "text" }
const _hoisted_24 = { class: "grid grid-cols-[24px_auto] gap-x-6 mb-16" }
const _hoisted_25 = { class: "flex justify-center mb-12" }
const _hoisted_26 = {
  key: 1,
  class: "h-screen bg-[var(--bg-color)]"
}
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_28 = [
  _hoisted_27
]
const _hoisted_29 = { class: "flex flex-col items-center justify-center gap-y-5 h-full" }

import { useWindowSize } from '@vueuse/core';
import { vMaska } from 'maska';
import { ref, computed } from 'vue';
import BaseTypography from '@/components/common/BaseTypography.vue';
import BaseButton from '@/components/common/BaseButton.vue';

type FormDataType = {
    excursion: string;
    childrens?: number;
    adults: number;
    date: string;
    name: string;
    email?: string;
    connect?: string;
    phone: string;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'ExcursionForm',
  emits: ["close"],
  setup(__props, { emit: __emit }) {

const emit = __emit;

const { width } = useWindowSize();

const options = { mask: '+7 (###) ###-##-##' };

const form = ref<FormDataType>({} as FormDataType);
const agreement = ref<boolean>(false);
const sended = ref<boolean>(false);

const sendForm = () => {
    // ToDo: подключить PhPMailer.
    console.log('form:', form.value);
    sended.value = true;
};

const isDisabled = computed(() => {
    return !(
        form.value.excursion &&
        form.value.adults &&
        form.value.date &&
        form.value.name &&
        /^\+7 \(\d{3}\) \d{3}-\d{2}-\d{2}$/.test(form.value.phone) &&
        agreement.value
    );
});

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (!sended.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", {
          class: "absolute top-16 right-10 cursor-pointer",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('close')))
        }, _hoisted_3),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(BaseTypography, {
            text: "Бронирование",
            type: _unref(width) > 768 ? 'subtitle' : 'title-m',
            color: "var(--black-color)"
          }, null, 8, ["type"])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createVNode(BaseTypography, {
                text: "Общая информация",
                type: "body2-m",
                color: "var(--primary-color)",
                class: "mb-10"
              }),
              _createElementVNode("label", _hoisted_8, [
                _createVNode(BaseTypography, {
                  text: "Название экскурсии*",
                  type: _unref(width) > 768 ? 'special-body2' : 'body2-m',
                  color: "var(--black-color)"
                }, null, 8, ["type"])
              ]),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.value.excursion) = $event)),
                id: "excursion",
                name: "excursion",
                placeholder: "О чем молчат дворы Васильевского острова",
                class: "edit bk",
                type: "text",
                required: ""
              }, null, 512), [
                [_vModelText, form.value.excursion]
              ])
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("label", _hoisted_10, [
                _createVNode(BaseTypography, {
                  text: "Дата экскурсии*",
                  type: _unref(width) > 768 ? 'special-body2' : 'body2-m',
                  color: "var(--black-color)"
                }, null, 8, ["type"])
              ]),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.value.date) = $event)),
                id: "date",
                name: "date",
                placeholder: "01.03.2024",
                class: "edit bk",
                type: "text",
                required: ""
              }, null, 512), [
                [_vModelText, form.value.date]
              ])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("label", _hoisted_12, [
                _createVNode(BaseTypography, {
                  text: "Количество взрослых*",
                  type: _unref(width) > 768 ? 'special-body2' : 'body2-m',
                  color: "var(--black-color)"
                }, null, 8, ["type"])
              ]),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((form.value.adults) = $event)),
                id: "adults",
                name: "adults",
                placeholder: "2",
                class: "edit bk",
                type: "number",
                required: ""
              }, null, 512), [
                [_vModelText, form.value.adults]
              ])
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("label", _hoisted_14, [
                _createVNode(BaseTypography, {
                  text: "Количество детей",
                  type: _unref(width) > 768 ? 'special-body2' : 'body2-m',
                  color: "var(--black-color)"
                }, null, 8, ["type"])
              ]),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((form.value.childrens) = $event)),
                id: "childrens",
                name: "childrens",
                placeholder: "2",
                class: "edit bk",
                type: "number"
              }, null, 512), [
                [_vModelText, form.value.childrens]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              _createVNode(BaseTypography, {
                text: "Обратная связь",
                type: "body2-m",
                color: "var(--primary-color)",
                class: "mb-10"
              }),
              _createElementVNode("label", _hoisted_17, [
                _createVNode(BaseTypography, {
                  text: "Ваше Имя*",
                  type: _unref(width) > 768 ? 'special-body2' : 'body2-m',
                  color: "var(--black-color)"
                }, null, 8, ["type"])
              ]),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((form.value.name) = $event)),
                id: "name",
                name: "name",
                placeholder: "Иван",
                class: "edit bk",
                type: "text",
                required: ""
              }, null, 512), [
                [_vModelText, form.value.name]
              ])
            ]),
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("label", _hoisted_19, [
                _createVNode(BaseTypography, {
                  text: "Ваш номер телефона*",
                  type: _unref(width) > 768 ? 'special-body2' : 'body2-m',
                  color: "var(--black-color)"
                }, null, 8, ["type"])
              ]),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((form.value.phone) = $event)),
                placeholder: "+7(000)000-00-00",
                id: "phone",
                name: "phone",
                class: "edit bk",
                type: "text",
                required: ""
              }, null, 512), [
                [_vModelText, form.value.phone],
                [_unref(vMaska), void 0, options]
              ])
            ]),
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("label", _hoisted_21, [
                _createVNode(BaseTypography, {
                  text: "Ваша электронная почта",
                  type: _unref(width) > 768 ? 'special-body2' : 'body2-m',
                  color: "var(--black-color)"
                }, null, 8, ["type"])
              ]),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((form.value.email) = $event)),
                placeholder: "ivan.ivanov@mail.ru",
                id: "email",
                name: "email",
                class: "edit bk",
                type: "email"
              }, null, 512), [
                [_vModelText, form.value.email]
              ])
            ]),
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("label", _hoisted_23, [
                _createVNode(BaseTypography, {
                  text: "Ваше сообщение",
                  type: _unref(width) > 768 ? 'special-body2' : 'body2-m',
                  color: "var(--black-color)"
                }, null, 8, ["type"])
              ]),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((form.value.connect) = $event)),
                id: "text",
                name: "text",
                placeholder: "Ваше сообщение...",
                class: "edit bk",
                type: "text"
              }, null, 512), [
                [_vModelText, form.value.connect]
              ])
            ]),
            _createElementVNode("div", _hoisted_24, [
              _createElementVNode("div", {
                class: _normalizeClass(["h-6 w-6 border-[4px] border-[var(--primary-color)] rounded-full cursor-pointer", { 'border-[var(--secondary-color)]': agreement.value }]),
                onClick: _cache[9] || (_cache[9] = () => (agreement.value = !agreement.value))
              }, null, 2),
              _createElementVNode("div", null, [
                _createVNode(BaseTypography, {
                  text: "Я согласен(а) на обработку персональных данных на условиях, изложенных в ",
                  type: "caption-m",
                  tag: "span"
                }),
                _createVNode(_component_router_link, { to: "/consent" }, {
                  default: _withCtx(() => [
                    _createVNode(BaseTypography, {
                      text: "Согласии на обработку персональных данных ",
                      type: "caption-m",
                      class: "underline",
                      tag: "span"
                    })
                  ]),
                  _: 1
                }),
                _createVNode(BaseTypography, {
                  text: "и ",
                  type: "caption-m",
                  tag: "span"
                }),
                _createVNode(_component_router_link, { to: "/policy" }, {
                  default: _withCtx(() => [
                    _createVNode(BaseTypography, {
                      text: "Политике.",
                      type: "caption-m",
                      class: "underline",
                      tag: "span"
                    })
                  ]),
                  _: 1
                })
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_25, [
          _createVNode(BaseButton, {
            text: "Отправить",
            type: _unref(width) > 768 ? 'subtitle4' : 'subtitle4-m',
            color: "var(--base-white)",
            ui: isDisabled.value ? 'disabled' : 'primary-with-back',
            disabled: isDisabled.value,
            onClick: sendForm
          }, null, 8, ["type", "ui", "disabled"])
        ])
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_26, [
        _createElementVNode("div", {
          class: "absolute top-16 right-10 cursor-pointer",
          onClick: _cache[10] || (_cache[10] = ($event: any) => (emit('close')))
        }, _hoisted_28),
        _createElementVNode("div", _hoisted_29, [
          _createVNode(BaseTypography, {
            text: "Забронировано!",
            type: "subtitle2-m"
          }),
          _createVNode(BaseTypography, {
            text: "Наш специалист вскоре свяжется с Вами.",
            type: "subtitle2-m"
          })
        ])
      ]))
}
}

})